import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { SavedRepliesEmptyContent } from 'pages/settings/pages/savedReplies/ui/SavedRepliesEmptyContent'
import {
  SavedRepliesProvider,
  useSavedRepliesContext,
} from 'pages/settings/pages/savedReplies/context/savedRepliesContext'
import { SavedRepliesHeader } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesHeader/SavedRepliesHeader'
import { SavedRepliesSearch } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesSearch/SavedRepliesSearch'
import { SavedRepliesListContent } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesListContent/SavedRepliesListContent'

import styles from './styles.module.scss'

const SavedReplies = observer(() => {
  const [initialLoading, isInitialLoading] = useState(true)
  const { init, showEmptyContent, reset } = useSavedRepliesContext()

  useEffect(() => {
    init().then(() => isInitialLoading(false))
    return () => {
      reset()
    }
  }, [])

  if (initialLoading) return <SpinnerLoader ariaLabel={'SavedRepliesPage'} />
  if (showEmptyContent) return <SavedRepliesEmptyContent />

  return (
    <div className={styles.content}>
      <SavedRepliesHeader />
      <SavedRepliesSearch />
      <div className={styles.savedRepliesContent}>
        <SavedRepliesListContent />
        <Outlet />
      </div>
    </div>
  )
})

export const SavedRepliesPageLayout = observer(() => (
  <FullPageWrapper className={styles.page}>
    <SavedRepliesProvider>
      <SavedReplies />
    </SavedRepliesProvider>
  </FullPageWrapper>
))
